var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{attrs:{"append-icon":"mdi-theme-light-dark","color":"primary"},on:{"change":function($event){return _vm.changeMode()}},model:{value:(_vm.darkMode),callback:function ($$v) {_vm.darkMode=$$v},expression:"darkMode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }